import api from "../apiConfig";

const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  listOnlineUsers(params) {
    const p = paramsFactory(params);
    const config = {};
    if (
      params &&
      (params.is_excel === 1 ||
        params.is_excel === true ||
        params.is_excel === "1" ||
        params.is_excel === "true")
    ) {
      config.responseType = "blob";
    }
    return api.get(`/api/v1/list-online-users?${p}`, config);
  },
  exportToExcel(params) {
    const p = paramsFactory({ ...params, is_excel: 1 });
    return api.get(`/api/v1/list-online-users?${p}`, {
      responseType: "blob",
    });
  },
};
